import React from 'react';
import { Box, FormControl, FormHelperText, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';
import { useAtom, useAtomValue, WritableAtom } from 'jotai';
import { errorAtom } from 'atoms/error';
import { authTokenAtom } from 'atoms/authAtoms';
import { useCalculations } from 'utils/hooks/useRToolTree';
import { useAutoSelectSingle } from 'utils/hooks/useAutoSelectSingle';
import { Config } from 'atoms/Rtool/newConfigAtoms';

type Props = {
    atom: WritableAtom<string, [newProjectId: string], void>;
    config: Config;
};

export const CalculationSelect: React.FC<Props> = ({ atom, config }) => {
    const authToken = useAtomValue(authTokenAtom);
    const [calculationId, setcalculationId] = useAtom(atom);
    const [error] = useAtom(errorAtom);
    const { items: calculations, loading } = useCalculations(authToken, config);
    // 選択肢が1件のみの段は自動選択し、一意に定まる限り下位へ連鎖させる
    useAutoSelectSingle(calculations, loading, calculationId, setcalculationId);

    return (
        <Box sx={{ flex: '1 1 calc(50% - 16px)' }}>
            <FormControl fullWidth disabled={!config.unit_id || loading} error={Boolean(error)}>
                <InputLabel id="calculation-select-label">Calculation</InputLabel>
                <Select
                    labelId="calculation-select-label"
                    value={calculationId}
                    label="calculation"
                    onChange={(e) => setcalculationId(e.target.value as string)}
                >
                    <MenuItem value="">
                        <em>None</em>
                    </MenuItem>
                    {calculations.map((calculation) => (
                        <MenuItem key={calculation} value={calculation}>
                            {calculation}
                        </MenuItem>
                    ))}
                </Select>
                {error && <FormHelperText>{error}</FormHelperText>}
                {loading && (
                    <CircularProgress
                        size={24}
                        sx={{ position: 'absolute', top: '50%', right: 16, mt: '-12px' }}
                    />
                )}
            </FormControl>
        </Box>
    );
};
